module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"import_data":"导入数据","file":"文件","file_type":"文件类型：","submit":"提交","select_file":"请选择文件","check_params":"请检查参数！！","import_success":"导入成功"},"en":{"import_data":"Import Data","file":"File","file_type":"File type: ","submit":"Submit","select_file":"Please select a file","check_params":"Please check the parameters!!","import_success":"Import successful"}}')
  delete Component.options._Ctor
}
